import React from "react"
import {
    Modal,
    ModalTitle,
    TitleSection,
    ContentSection,
    FooterSection,
    Label,
    Button,
    Row,
    Column,
    Color,
} from "trux"
import { useHistory } from "react-router-dom"
import { DetailsForm } from "./RosterInvite/DetailsForm"

export const EditFamilyMemberModal = (props) => {
    const history = useHistory()

    const handleCloseButtonClick = (e) => {
        e.preventDefault()
        history.goBack()
    }

    return (
        <Modal
            className="RemoveFamily"
            open
            onShadeClick={(e) => {
                handleCloseButtonClick(e)
            }}
        >
            <TitleSection onCloseClick={handleCloseButtonClick}>
                <ModalTitle content={"{Family member name}"} />
            </TitleSection>
            <ContentSection>
                <DetailsForm />
            </ContentSection>
            <FooterSection>
                <Row width="100%">
                    <Button
                        width="100%"
                        className="button"
                        content={"Save changes"}
                    />
                </Row>
            </FooterSection>
        </Modal>
    )
}
